import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MasterHelper } from 'src/app/core/utilities';
import { UserProfile } from 'src/app/core/models/user';
import { MatChipInputEvent } from '@angular/material/chips';
import { AlertDialogModel } from 'src/app/core/models/view-model';
import { RegulationService } from 'src/app/core/services/regulation';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LibraryType } from 'src/app/core/enums/regulator/regulator-status';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { SessionService } from './../../../core/services/auth/session.service';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FilterViewModel, MasterFilterModel } from 'src/app/core/models/regulation';
import { LibraryDataModel } from 'src/app/core/models/view-model/library-data-model';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { ChangeViewerLibrary } from 'src/app/core/models/regulation/change-viewer-library';
import { DynamicLibraryFilter } from 'src/app/core/models/regulation/dynamic-library-filter';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DynamicRegulationLibrary } from 'src/app/core/models/regulation/dynamic-regulation-library';
import { UserService } from 'src/app/core/services/user';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GlobalService } from 'src/app/core/services/global/global.service';

@Component({
  selector: 'app-regulation-library-dialog',
  templateUrl: './regulation-library-dialog.component.html',
  styleUrls: ['./regulation-library-dialog.component.scss']
})
export class RegulationLibraryDialogComponent implements OnInit {

  user: UserProfile;
  isWarningShow = false;
  regulationLibrary: Array<ChangeViewerLibrary>;
  isAllow = true;
  existingId: number;
  existingLibrary: ChangeViewerLibrary= new ChangeViewerLibrary();
  libraryType!: LibraryType;
  isDeleteLoader = false;
  libraryData: LibraryDataModel;
  isInputDisabled = false;
  isSelectDisabled = false;
  isExist = false;
  isGlobalLibrary = false;

  masterFilters: MasterFilterModel;
  regulationFilter: DynamicLibraryFilter;
  searchedTopics: FilterViewModel[] = [];
  searchedRegulators: FilterViewModel[] = [];
  searchedCountries: FilterViewModel[] = [];
  searchedGeographies: FilterViewModel[] = [];
  searchedRulebooks: ItemIdModel[] = [];
  selectedRulebooks: ItemIdModel[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];
  searchTerm: FormControl = new FormControl();
  searchRegulatorCntrl: FormControl = new FormControl();
  searchCountryCntrl: FormControl = new FormControl();
  searchRuleTopicFormControl: FormControl = new FormControl();
  searchGeographyCntrl: FormControl = new FormControl();
  keyCtrl = new FormControl();
  filteredKeywords: Observable<string[]> ;

  @ViewChild('regulatorInput')
  regulatorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('regulatorAutocomplete')
  regulatorAutocomplete!: MatAutocomplete;

  @ViewChild('countryInput')
  countryInput!: ElementRef<HTMLInputElement>;
  @ViewChild('countryAutoComplete')
  countryAutoComplete!: MatAutocomplete;

  @ViewChild('geographyInput')
  geographyInput!: ElementRef<HTMLInputElement>;
  @ViewChild('geographyAutoComplete')
  geographyAutoComplete!: MatAutocomplete;
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  isAddRulebookShow:boolean=false;
  keywords: string[] = [];
  //searchedKeywords = [];


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AlertDialogModel,
    public dialogRef: MatDialogRef<RegulationLibraryDialogComponent>, private regulationService: RegulationService,
    private sessionService: SessionService, private analyticService: AnalyticsService,private _userService: UserService,
    private _globalService: GlobalService
  ) {
    this.user = new UserProfile();
    this.regulationLibrary = [];
    this.regulationFilter = new DynamicLibraryFilter();
    this.masterFilters = new MasterFilterModel();
    this.existingLibrary = new ChangeViewerLibrary();
    this.existingId = 0;
    this.libraryData = new LibraryDataModel();
    this.filteredKeywords = this.keyCtrl.valueChanges.pipe(map((key: string | null) => key ? this._filter(key) : this.keywords.slice()));
  }

  ngOnInit(): void {
    this.libraryType = this.data.IsAction ? LibraryType.Dynamic : LibraryType.Static;
    this.getUserProfile();
  }

  async getUserProfile() {
    this.user = await this._globalService.getLoginUserData();
    this.fetchRegulationLibrary();
    if (this.data.IsAction) {
      this.getMasterFilters();
    }
    this.fetchLibraryRulebook();
  }

  fetchRegulationLibrary(): void {
    this.libraryData.isHide = false;
    this.regulationService.getRegulationLibrary('OrderNo', false).subscribe((data: Array<ChangeViewerLibrary>) => {
      this.regulationLibrary = data;
      if (data && data.filter(a => a.isActive).length > 0) {
        this.regulationService.regulationLibrary = data.filter(a => a.isActive);
        this.isAllow = data.filter(a => a.isActive).length < 100 ? true : false;
        this._userService.userLibrary=this.regulationService.regulationLibrary ;
      } else {
        this.regulationService.regulationLibrary =[];
        this._userService.userLibrary=this.regulationService.regulationLibrary ;
        this.isAllow = true;
      }
    });
  }

  fetchLibraryRulebook(): void {
    this.analyticService.isGlobalLibraryOn().subscribe((res=>{
      this.isGlobalLibrary = res;
      if(this.isGlobalLibrary == true){
        this.analyticService.getLibraryRulebook().subscribe((data: ItemIdModel[]) => {
          this.searchedRulebooks = data;
          this.isAddRulebookShow=true;
        },
         error =>{
          if(error && error=="Authorization failed."){
            this.isAddRulebookShow=false;
          }
          else{
            this.isAddRulebookShow=true;
          }
         }
        );
      }
    }));


  }

  onClickSave(): void {
    if (+this.existingId === 0) {
      const libraryExist = this.regulationLibrary.filter(a => a.libraryName.toLowerCase() ===
        this.existingLibrary.libraryName.toLowerCase());
      if (libraryExist.length > 0) {
        this.isExist = true;
        setTimeout(() => {
          this.isExist = false;
        }, 2000);
      } else {
        this.onConfirmClick();
      }
    } else {
      this.onConfirmClick();
    }
  }

  onConfirmClick(): void {
    if (+this.existingId > 0) {
      let library = this.regulationLibrary.find(a => +a.id === +this.existingId);
      if (library) {this.existingLibrary=library;}
    }
    this.libraryData.libraryId = this.existingLibrary.id;
    this.libraryData.libraryName = this.existingLibrary.libraryName.trim();
    this.libraryData.isGlobal = this.existingLibrary.isGlobal;
    this.libraryData.parentId = this.existingLibrary.parentId;
    this.libraryData.libraryType = this.existingLibrary.id > 0 ? this.existingLibrary.libraryType :
      (this.data.IsAction ? LibraryType.Dynamic : LibraryType.Static);
    this.libraryData.filterJson = JSON.stringify(this.regulationFilter);
    this.libraryData.rulebooks = this.selectedRulebooks.length > 0
      ? MasterHelper.getStringArrayFromObjectArray(this.selectedRulebooks) : [];
    if (!this.libraryData.isRulebook && this.existingId === 0 && !this.libraryData.libraryName) {
      this.alertMessage();
    } else if (this.libraryData.libraryType === LibraryType.Dynamic && this.libraryData.isRulebook
      && this.existingId === 0 && !this.libraryData.libraryName) {
      this.alertMessage();
    } else {
      this.dialogRef.close(this.libraryData);
    }
  }

  alertMessage(): void {
    this.isWarningShow = true;
    setTimeout(() => {
      this.isWarningShow = false;
    }, 3000);
  }

  getMasterFilters(): void {
    this.regulationService.getMasterFilters().subscribe((data: MasterFilterModel) => {
      this.masterFilters = data;
      this.searchedRegulators = this.masterFilters.regulators;
      this.searchedCountries = this.masterFilters.countries;
      this.searchedGeographies=this.masterFilters.geographys;

      this.searchRegulatorCntrl.valueChanges.subscribe((term: any) => {
        this.searchedRegulators = term ? this.filterRegulators(term) : this.masterFilters.regulators;
      });

      this.searchCountryCntrl.valueChanges.subscribe((term: any) => {
        this.searchedCountries = term ? this.filterCountry(term) : this.masterFilters.countries;
      });
      this.searchGeographyCntrl.valueChanges.subscribe((term: any) => {
        this.searchedGeographies = term ? this.filterGeography(term) : this.masterFilters.geographys;
      });
    });
  }

  filterRegulators(search: string): any {
    return this.searchedRegulators.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  filterCountry(search: string): any {
    return this.searchedCountries.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterGeography(search: string): any {
    return this.searchedGeographies.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  getFilterJson(): void {
    if (this.libraryType === LibraryType.Dynamic) {
      if (this.existingId > 0) {
        this.regulationService.getLibraryFilterJson(this.existingId).subscribe((result: DynamicRegulationLibrary) => {
          if (result) {
            this.regulationFilter = JSON.parse(result.filterJson) as DynamicLibraryFilter;
          }
        });
      } else {
        this.regulationFilter = new DynamicLibraryFilter();
      }
    }
    if (this.existingId > 0) {
      this.isInputDisabled = true;
      this.libraryData.isHide = !this.regulationLibrary.find(a => +a.id === +this.existingId)?.isActive;
    } else {
      this.isInputDisabled = false;
    }
    if (+this.regulationLibrary.filter(a => a.isActive).length === 30) {
      this.isAllow = this.existingId > 0 ? true : false;
    }
  }

  addRegulator(event: MatChipInputEvent): void {
    if (!this.regulatorAutocomplete.isOpen) {
      const value = event.value;
      if (!this.regulationFilter.regulator) {
        this.regulationFilter.regulator = [];
        this.regulationFilter.regulator.push(value);
      }
      if ((value || '').trim()) {
        (this.regulationFilter.regulator as string[]).push(value);
      }
      event.chipInput!.clear();
      this.searchRegulatorCntrl.setValue(null);
    }
  }

  removeRegulator(regulator: string): void {
    if (!this.regulationFilter.regulator) {
      this.regulationFilter.regulator = [];
    }
    const index = (this.regulationFilter.regulator as string[]).indexOf(regulator);
    if (index >= 0) {
      (this.regulationFilter.regulator as string[]).splice(index, 1);
    }
  }

  selectedRegulatorEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.regulationFilter.regulator) {
      this.regulationFilter.regulator.push(event.option.viewValue);
    } else {
      this.regulationFilter.regulator = [];
      this.regulationFilter.regulator.push(event.option.viewValue);
    }
    this.regulatorInput.nativeElement.value = '';
    this.searchRegulatorCntrl.setValue(null);
    this.searchRegulatorCntrl.disable();
    this.searchRegulatorCntrl.enable();
  }

  addCountry(event: MatChipInputEvent): void {
    if (!this.countryAutoComplete.isOpen) {
      const value = event.value;
      if (!this.regulationFilter.country) {
        this.regulationFilter.country = [];
        this.regulationFilter.country.push(value);
      }
      if ((value || '').trim()) {
        (this.regulationFilter.country as string[]).push(value);
      }
      event.chipInput!.clear();
      this.searchCountryCntrl.setValue(null);

      this.searchedRegulators = this.filterRegulatorByCountry();
      this.regulationFilter.regulator = [];
    }
  }

  removeCountry(country: string): void {
    if (!this.regulationFilter.country) {
      this.regulationFilter.country = [];
    }
    const index = (this.regulationFilter.country as string[]).indexOf(country);
    if (index >= 0) {
      (this.regulationFilter.country as string[]).splice(index, 1);
      if (this.regulationFilter.country.length > 0) {
        this.searchedRegulators = this.filterRegulatorByCountry();
      } else {
        this.searchedRegulators = this.masterFilters.regulators;
      }
      this.regulationFilter.regulator = [];
    }
  }

  selectedCountryEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.regulationFilter.country) {
      this.regulationFilter.country.push(event.option.viewValue);
    } else {
      this.regulationFilter.country = [];
      this.regulationFilter.country.push(event.option.viewValue);
    }
    this.countryInput.nativeElement.value = '';
    this.searchCountryCntrl.setValue(null);
    this.searchCountryCntrl.disable();
    this.searchCountryCntrl.enable();

    this.searchedRegulators = this.filterRegulatorByCountry();
    this.regulationFilter.regulator = [];
  }

  filterRegulatorByCountry(): FilterViewModel[] {
    const regArray: FilterViewModel[] = [];
    this.regulationFilter.country.forEach(element => {
      const resultArr = this.masterFilters.regulators.filter(option =>
        option.name.toLowerCase().includes(element.toLowerCase()));
      resultArr.forEach(element2 => {
        regArray.push(element2);
      });
    });
    return regArray;
  }

  addGeography(event: MatChipInputEvent): void {
    if (!this.geographyAutoComplete.isOpen) {
      const value = event.value;
      if (!this.regulationFilter.geography) {
        this.regulationFilter.geography = [];
        this.regulationFilter.geography.push(value);
      }
      if ((value || '').trim()) {
        (this.regulationFilter.geography as string[]).push(value);
      }
      event.chipInput!.clear();
      this.searchGeographyCntrl.setValue(null);
      this.searchedCountries = this.filterCountryByGeography();
      this.searchedRegulators = this.filterRegulatorByGeography();
      this.regulationFilter.regulator = [];
      this.regulationFilter.country=[];
    }
  }

  removeGeography(Geography: string): void {
    if (!this.regulationFilter.geography) {
      this.regulationFilter.geography = [];
    }
    const index = (this.regulationFilter.geography as string[]).indexOf(Geography);
    if (index >= 0) {
      (this.regulationFilter.geography as string[]).splice(index, 1);

      if (this.regulationFilter.geography.length > 0) {
        this.searchedCountries = this.filterCountryByGeography();
        this.searchedRegulators = this.filterRegulatorByGeography();
      } else {
        this.searchedCountries = this.masterFilters.countries;
        this.searchedRegulators = this.masterFilters.regulators;
      }
      this.regulationFilter.regulator = [];
      this.regulationFilter.country=[];
    }
  }

  selectedGeographyEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.regulationFilter.geography) {
      this.regulationFilter.geography.push(event.option.viewValue);
    } else {
      this.regulationFilter.geography = [];
      this.regulationFilter.geography.push(event.option.viewValue);
    }
    this.geographyInput.nativeElement.value = '';
    this.searchGeographyCntrl.setValue(null);
    this.searchGeographyCntrl.disable();
    this.searchGeographyCntrl.enable();
    this.searchedCountries = this.filterCountryByGeography();
    this.searchedRegulators = this.filterRegulatorByGeography();
    this.regulationFilter.regulator = [];
    this.regulationFilter.country=[];

    // this.searchedRegulators = this.filterRegulatorByCountry();
    // this.regulationFilter.regulator = [];
  }

  filterRegulatorByGeography(): FilterViewModel[] {
    const regArray:FilterViewModel[] = [];
    this.regulationFilter.geography.forEach(element => {
      const resultArr = this.masterFilters.regulators.filter(option =>
      option.geography.toLowerCase().includes(element.toLowerCase()));
      resultArr.forEach(element2 => {
        regArray.push(element2);
      });
    });
    return regArray;
  }
  filterCountryByGeography(): FilterViewModel[] {
    const conArray: FilterViewModel[] = [];
    this.regulationFilter.geography.forEach(element => {
      const resultArr = this.masterFilters.countries.filter(option =>
        option.geography.toLowerCase().includes(element.toLowerCase()));
      resultArr.forEach(element2 => {
        conArray.push(element2);
      });
    });
    return conArray;
  }
  addType(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      this.regulationFilter.pubType.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeType(type: string): void {
    const index = this.regulationFilter.pubType.indexOf(type);
    if (index >= 0) {
      this.regulationFilter.pubType.splice(index, 1);
    }
  }

  addTopic(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      this.regulationFilter.ruleTopic.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeTopic(item: string): void {
    const index = this.regulationFilter.ruleTopic.indexOf(item);
    if (index >= 0) {
      this.regulationFilter.ruleTopic.splice(index, 1);
    }
  }

  addTitle(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      this.regulationFilter.title.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeTitle(item: string): void {
    const index = this.regulationFilter.title.indexOf(item);
    if (index >= 0) {
      this.regulationFilter.title.splice(index, 1);
    }
  }

  deleteLibrary(): void {
    this.isDeleteLoader = true;
    this.regulationService.removeRegulationLibrary(this.existingId).subscribe((result: any) => {
      this.isDeleteLoader = false;
      this.existingId = 0;
      this.isInputDisabled = false;
      this.regulationFilter = new DynamicLibraryFilter();
      this.fetchRegulationLibrary();
    });
  }

  getIconClass(type: LibraryType): string {
    return type === LibraryType.Static ? 'fa fa-thumb-tack' : 'fa fa-bolt';
  }

  disabledItem(filter: boolean): void {
    if (this.libraryType === LibraryType.Static) {
      this.isInputDisabled = filter;
      this.isSelectDisabled = filter;
    }
    this.libraryData.isRulebook = filter;
  }

  add(event: MatChipInputEvent): void {
    if (!this.autoKeyword.isOpen) {
      const value = event.value;
      let filterResult = this.regulationFilter.SearchQuery?.filter((option: string) => option.trim() == value.trim());
      if (filterResult && filterResult.length > 0) {
        event.chipInput!.clear();
        return;
      }
      if ((value || '').trim()) {
        this.regulationFilter.SearchQuery.push(value.trim());
      }
      event.chipInput!.clear();
      this.keyCtrl.setValue(null);
    }
  }
  remove(fruit: string): void {
    const index = this.regulationFilter.SearchQuery.indexOf(fruit);
    if (index >= 0) {
      this.regulationFilter.SearchQuery.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.regulationFilter.SearchQuery.push(event.option.viewValue);
    this.keywordInput.nativeElement.value = '';
    this.keyCtrl.setValue(null);
    this.keyCtrl.disable();
    this.keyCtrl.enable();
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.keywords.filter(
      fruit => fruit.toLowerCase().indexOf(filterValue) === 0
    );
  }
  //topic Negative filter
  removeTopicNegativeFilter(item: string): void {
    const index = this.regulationFilter.topicNegativeFilter.indexOf(item);
    if (index >= 0) {
      this.regulationFilter.topicNegativeFilter.splice(index, 1);
    }
  }
  addTopicNegativeFilter(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      if(!this.regulationFilter.topicNegativeFilter){
        this.regulationFilter.topicNegativeFilter=[];
      }
      this.regulationFilter.topicNegativeFilter.push(value.trim());
    }
    event.chipInput!.clear();
  }
  //title Negative filter
  removeTitleNegativeFilter(item: string): void {
    const index = this.regulationFilter.titleNegativeFilter.indexOf(item);
    if (index >= 0) {
      this.regulationFilter.titleNegativeFilter.splice(index, 1);
    }
  }
  addTitleNegativeFilter(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      if(!this.regulationFilter.titleNegativeFilter){
        this.regulationFilter.titleNegativeFilter=[];
      }
      this.regulationFilter.titleNegativeFilter.push(value.trim());
    }
    event.chipInput!.clear();
  }
}
